import React from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useTranslation, Trans } from "react-i18next";

const convertArrayToCSV = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
        return "";
    }
    const headers = Object.keys(data[0]);
    const rows = data.map((row) =>
        headers.map((header) => JSON.stringify(row[header] || "")).join(",")
    );
    return [headers.join(","), ...rows].join("\n");
};

const EnrichPreview = ({
    handleBack,
    handleContinue,
    navigateToImportPage,
    filteredRowsNoZero,
    validFilteredRows,
    onSubmitImport,
    setState,
    state,
}) => {
    const { t } = useTranslation("common");

    const invalidCount = filteredRowsNoZero.length;
    const readyCount = validFilteredRows.length;
    const totalEntries = readyCount + invalidCount;

    const csvString = convertArrayToCSV(validFilteredRows);
    const csvBlob = new Blob([csvString], { type: "text/csv" });
    const updatedFile = new File([csvBlob], state.file?.name || "enrichment.csv", { type: "text/csv" });

    const handleSubmit = () => {
        if (readyCount === 0) {
            return;
        }

        const formData = new FormData();
        formData.append("file", updatedFile, updatedFile.name);

        setState((prev) => ({ ...prev, uploading: true }));
        onSubmitImport(formData);
        handleContinue();
    };

    return (
        <div>
            <Card className="main-upload-card">
                <div className="pl-4 pt-5 enrich-preview-content">
                    <p className="title-text mb-0">{t("business_customers.enrich_validate_title")}</p>
                    <p className="sub_text mb-5">
                        <Trans
                            i18nKey="business_customers.enrich_validate_description"
                            components={{ 1: <strong /> }}
                        />
                    </p>

                    <div className="enrich-validate-banner">
                        <Trans
                            i18nKey="business_customers.enrich_validate_banner"
                            values={{ ready: readyCount, total: totalEntries }}
                            components={{
                                1: <strong className="enrich-validate-banner-count" />,
                                2: <strong className="enrich-validate-banner-status" />,
                            }}
                        />
                    </div>

                    {readyCount === 0 && (
                        <p className="import-text mb-3 reveknew_red">
                            {t("business_customers.enrich_no_valid_records")}
                        </p>
                    )}

                    <div className="buttons-cont">
                        <div className="back-btn mt-6">
                            <Button className="import_back_button" onClick={handleBack}>
                                {t("Back")}
                            </Button>
                        </div>
                        <div className="cont-btn">
                            <Button className="import_cancel_button" onClick={navigateToImportPage}>
                                {t("cancel")}
                            </Button>
                            <Button
                                className="import_button steps-button py-2"
                                onClick={handleSubmit}
                                disabled={readyCount === 0}
                            >
                                {t("business_customers.enrich_submit_button")}
                            </Button>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default EnrichPreview;
